/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { validateApiKeyRequestRequestSchema } from "./validateApiKeyRequestRequestSchema.ts";

export const deviceOrgUnitValidateApiKeyCreatePathOrgUnitIdSchema = z.uuid();

export const deviceOrgUnitValidateApiKeyCreateStatus200Schema = z.any();

export const deviceOrgUnitValidateApiKeyCreateStatus403Schema = errorResponseSchema;

export const deviceOrgUnitValidateApiKeyCreateResponseSchema = z.union([
	deviceOrgUnitValidateApiKeyCreateStatus200Schema,
	deviceOrgUnitValidateApiKeyCreateStatus403Schema,
]);

export const deviceOrgUnitValidateApiKeyCreateDataSchemaJson = validateApiKeyRequestRequestSchema.describe(
	"Сериализатор для валидации API-key, введенного на киоске.",
);

export const deviceOrgUnitValidateApiKeyCreateDataSchemaXml = validateApiKeyRequestRequestSchema.describe(
	"Сериализатор для валидации API-key, введенного на киоске.",
);

export const deviceOrgUnitValidateApiKeyCreateDataSchema = z.union([
	deviceOrgUnitValidateApiKeyCreateDataSchemaJson,
	deviceOrgUnitValidateApiKeyCreateDataSchemaXml,
]);
